import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --homie-between-row-padding: calc(30rem / var(--default-rem-px-count));
      --homie-between-column-padding: calc(24rem / var(--default-rem-px-count));
    }

    .homie-layout.mobile-rows-1 {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];

      .block-header {
        grid-row: 2;
      }
      .images-wrapper {
        grid-row: 2;
      }
    }
    .homie-layout.mobile-rows-2 {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];

      .block-header {
        grid-row: 2;
      }
      .images-wrapper {
        grid-row: 3;
      }
    }
    .homie-layout.mobile-rows-3 {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];

      .block-header {
        grid-row: 2;
      }
      .images-wrapper {
        grid-row: 3;
      }
    }

    .homie-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];
    }

    h2 {
      grid-column: 2 / 8;
      grid-row: 2;
      height: fit-content;
    }

    h3 {
      padding-top: calc(4rem / var(--default-rem-px-count));
      font-size: calc(10rem / var(--default-rem-px-count));
      line-height: calc(16rem / var(--default-rem-px-count));
      letter-spacing: -0.15px;
      font-weight: 400;
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      height: fit-content;
    }

    .has-images {
      h2 {
        margin-bottom: calc(40rem / var(--default-rem-px-count));
      }
      .description {
        margin-bottom: calc(40rem / var(--default-rem-px-count));
      }
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
      display: flex;
      gap: var(--homie-between-row-padding) var(--homie-between-column-padding);
    }

    .image-wrapper {
      grid-template-columns: 1fr;

      .image {
        width: 100%;
      }
    }

    .font-size-small {
      padding-top: calc(6rem / var(--default-rem-px-count));
    }

    .image > a,
    a > img {
      width: 120px;
    }

    img {
      width: 100%;
      max-width: 120px;
    }

    .three-per-row {
      overflow-x: auto;
    }

    @media (min-width: 600px) {
      .homie-layout.mobile-rows-1,
      .homie-layout.mobile-rows-2,
      .homie-layout.mobile-rows-3 {
        grid-template-areas:
          var(--top-padding-height)
          minmax(0, auto)
          var(--bottom-padding-height);
      }

      .homie-layout.has-images.mobile-rows-1,
      .homie-layout.has-images.mobile-rows-2,
      .homie-layout.has-images.mobile-rows-3 {
        grid-template-areas:
          var(--top-padding-height)
          minmax(0, auto)
          minmax(0, auto)
          var(--bottom-padding-height);
      }

      h2 {
        grid-row: 2;
        grid-column: 2 / 7;
        width: max-content;
      }

      h3 {
        padding-top: calc(10rem / var(--default-rem-px-count));
        font-size: calc(18rem / var(--default-rem-px-count));
        line-height: calc(24rem / var(--default-rem-px-count));
        letter-spacing: -0.54px;
      }

      .description {
        grid-row: 2;
        grid-column: 8 / 13;
      }

      .has-images {
        h2 {
          margin-bottom: calc(80rem / var(--default-rem-px-count));
        }
        .description {
          margin-bottom: calc(80rem / var(--default-rem-px-count));
        }
      }

      .images {
        grid-row: 3;
        grid-column: 2 / 14;
        gap: calc(2 * var(--between-column-padding))
          var(--between-column-padding);
        display: grid;
        max-width: 100%;
      }

      img {
        max-width: unset;
      }

      .image > a,
      a > img {
        width: 100%;
      }

      .three-per-row {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    @media (min-width: 1024px) {
      :host {
        --homie-between-row-padding: calc(40rem / var(--default-rem-px-count));
        --homie-between-column-padding: calc(
          32rem / var(--default-rem-px-count)
        );
      }
    }
  `,
];
